/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Date_PlaceholderInputs */

const en_common_date_placeholder = /** @type {(inputs: Common_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MM/DD/YYYY`)
};

const pt_br2_common_date_placeholder = /** @type {(inputs: Common_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DD/MM/AAAA`)
};

/**
* | output |
* | --- |
* | "MM/DD/YYYY" |
*
* @param {Common_Date_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const common_date_placeholder = /** @type {((inputs?: Common_Date_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Date_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_date_placeholder(inputs)
	return pt_br2_common_date_placeholder(inputs)
});